import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HomeShowcase from '../components/HomeShowcase';

interface HomePageProps {
  mode: 'light' | 'dark';
  setMode: (mode: 'light' | 'dark') => void;
}

const HomePage = ({ mode, setMode }: HomePageProps) => {
  const [isLoggedIn, setLoggedin] = useState<boolean>(false);

  return (
    <>
      <Header isLoggedIn={isLoggedIn} mode={mode} setMode={setMode} />
      <HomeShowcase />
      <Footer />
    </>
  );
};

export default HomePage;
